import { render, staticRenderFns } from "./bind-wechat.vue?vue&type=template&id=07b08e3d&"
import script from "./bind-wechat.vue?vue&type=script&lang=js&"
export * from "./bind-wechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports